/*
 *
 *
 *
 *   Copyright (c) 2022. TinyMedic Pvt Ltd  - All Rights Reserved.
 *   This file is part of the API module  of the project: TinyMedic-Platform.
 *
 *
 *   Proprietary and confidential.
 *
 *   Unauthorized copying of this file, via any medium is strictly prohibited.
 *    Any resources of   TinyMedic-Platform can not be copied and/or distributed without the express permission of TinyMedic Pvt Ltd.
 *
 *
 *
 */

import React, { useEffect } from 'react';
import { Link, useParams } from 'react-router-dom';
import { Button, Col, Row, UncontrolledTooltip } from 'reactstrap';
import { Translate } from 'react-jhipster';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

import { useAppDispatch, useAppSelector } from 'app/config/store';

import { getEntity } from './accounting-collection-ledger.reducer';

export const AccountingCollectionLedgerDetail = () => {
  const dispatch = useAppDispatch();

  const { id } = useParams<'id'>();

  useEffect(() => {
    dispatch(getEntity(id));
  }, []);

  const accountingCollectionLedgerEntity = useAppSelector(state => state.accountingCollectionLedger.entity);
  return (
    <Row>
      <Col md="8">
        <h2 data-cy="accountingCollectionLedgerDetailsHeading">
          <Translate contentKey="tinyMedicRestApp.accountingCollectionLedger.detail.title">AccountingCollectionLedger</Translate>
        </h2>
        <dl className="jh-entity-details">
          <dt>
            <span id="id">
              <Translate contentKey="tinyMedicRestApp.accountingCollectionLedger.id">Id</Translate>
            </span>
          </dt>
          <dd>{accountingCollectionLedgerEntity.id}</dd>
          <dt>
            <span id="ledgerNo">
              <Translate contentKey="tinyMedicRestApp.accountingCollectionLedger.ledgerNo">Ledger No</Translate>
            </span>
            <UncontrolledTooltip target="ledgerNo">
              <Translate contentKey="tinyMedicRestApp.accountingCollectionLedger.help.ledgerNo" />
            </UncontrolledTooltip>
          </dt>
          <dd>{accountingCollectionLedgerEntity.ledgerNo}</dd>
          <dt>
            <span id="amount">
              <Translate contentKey="tinyMedicRestApp.accountingCollectionLedger.amount">Amount</Translate>
            </span>
            <UncontrolledTooltip target="amount">
              <Translate contentKey="tinyMedicRestApp.accountingCollectionLedger.help.amount" />
            </UncontrolledTooltip>
          </dt>
          <dd>{accountingCollectionLedgerEntity.amount}</dd>
          <dt>
            <span id="remarks">
              <Translate contentKey="tinyMedicRestApp.accountingCollectionLedger.remarks">Remarks</Translate>
            </span>
            <UncontrolledTooltip target="remarks">
              <Translate contentKey="tinyMedicRestApp.accountingCollectionLedger.help.remarks" />
            </UncontrolledTooltip>
          </dt>
          <dd>{accountingCollectionLedgerEntity.remarks}</dd>
          <dt>
            <span id="pendingAmount">
              <Translate contentKey="tinyMedicRestApp.accountingCollectionLedger.pendingAmount">Pending Amount</Translate>
            </span>
            <UncontrolledTooltip target="pendingAmount">
              <Translate contentKey="tinyMedicRestApp.accountingCollectionLedger.help.pendingAmount" />
            </UncontrolledTooltip>
          </dt>
          <dd>{accountingCollectionLedgerEntity.pendingAmount}</dd>
          <dt>
            <span id="collectedById">
              <Translate contentKey="tinyMedicRestApp.accountingCollectionLedger.collectedById">Collected By Id</Translate>
            </span>
            <UncontrolledTooltip target="collectedById">
              <Translate contentKey="tinyMedicRestApp.accountingCollectionLedger.help.collectedById" />
            </UncontrolledTooltip>
          </dt>
          <dd>{accountingCollectionLedgerEntity.collectedById}</dd>
          <dt>
            <span id="collectedByType">
              <Translate contentKey="tinyMedicRestApp.accountingCollectionLedger.collectedByType">Collected By Type</Translate>
            </span>
            <UncontrolledTooltip target="collectedByType">
              <Translate contentKey="tinyMedicRestApp.accountingCollectionLedger.help.collectedByType" />
            </UncontrolledTooltip>
          </dt>
          <dd>{accountingCollectionLedgerEntity.collectedByType}</dd>
          <dt>
            <span id="depositedById">
              <Translate contentKey="tinyMedicRestApp.accountingCollectionLedger.depositedById">Deposited By Id</Translate>
            </span>
            <UncontrolledTooltip target="depositedById">
              <Translate contentKey="tinyMedicRestApp.accountingCollectionLedger.help.depositedById" />
            </UncontrolledTooltip>
          </dt>
          <dd>{accountingCollectionLedgerEntity.depositedById}</dd>
          <dt>
            <span id="depositedByType">
              <Translate contentKey="tinyMedicRestApp.accountingCollectionLedger.depositedByType">Deposited By Type</Translate>
            </span>
            <UncontrolledTooltip target="depositedByType">
              <Translate contentKey="tinyMedicRestApp.accountingCollectionLedger.help.depositedByType" />
            </UncontrolledTooltip>
          </dt>
          <dd>{accountingCollectionLedgerEntity.depositedByType}</dd>
          <dt>
            <span id="closed">
              <Translate contentKey="tinyMedicRestApp.accountingCollectionLedger.closed">Closed</Translate>
            </span>
            <UncontrolledTooltip target="closed">
              <Translate contentKey="tinyMedicRestApp.accountingCollectionLedger.help.closed" />
            </UncontrolledTooltip>
          </dt>
          <dd>{accountingCollectionLedgerEntity.closed ? 'true' : 'false'}</dd>
          <dt>
            <span id="entityId">
              <Translate contentKey="tinyMedicRestApp.accountingCollectionLedger.entityId">Entity Id</Translate>
            </span>
          </dt>
          <dd>{accountingCollectionLedgerEntity.entityId}</dd>
          <dt>
            <span id="active">
              <Translate contentKey="tinyMedicRestApp.accountingCollectionLedger.active">Active</Translate>
            </span>
            <UncontrolledTooltip target="active">
              <Translate contentKey="tinyMedicRestApp.accountingCollectionLedger.help.active" />
            </UncontrolledTooltip>
          </dt>
          <dd>{accountingCollectionLedgerEntity.active ? 'true' : 'false'}</dd>
          <dt>
            <span id="cursor">
              <Translate contentKey="tinyMedicRestApp.accountingCollectionLedger.cursor">Cursor</Translate>
            </span>
            <UncontrolledTooltip target="cursor">
              <Translate contentKey="tinyMedicRestApp.accountingCollectionLedger.help.cursor" />
            </UncontrolledTooltip>
          </dt>
          <dd>{accountingCollectionLedgerEntity.cursor}</dd>
          <dt>
            <span id="lastUpdated">
              <Translate contentKey="tinyMedicRestApp.accountingCollectionLedger.lastUpdated">Last Updated</Translate>
            </span>
            <UncontrolledTooltip target="lastUpdated">
              <Translate contentKey="tinyMedicRestApp.accountingCollectionLedger.help.lastUpdated" />
            </UncontrolledTooltip>
          </dt>
          <dd>{accountingCollectionLedgerEntity.lastUpdated}</dd>
          <dt>
            <span id="microSec">
              <Translate contentKey="tinyMedicRestApp.accountingCollectionLedger.microSec">Micro Sec</Translate>
            </span>
            <UncontrolledTooltip target="microSec">
              <Translate contentKey="tinyMedicRestApp.accountingCollectionLedger.help.microSec" />
            </UncontrolledTooltip>
          </dt>
          <dd>{accountingCollectionLedgerEntity.microSec}</dd>
          <dt>
            <span id="timestampEntry">
              <Translate contentKey="tinyMedicRestApp.accountingCollectionLedger.timestampEntry">Timestamp Entry</Translate>
            </span>
            <UncontrolledTooltip target="timestampEntry">
              <Translate contentKey="tinyMedicRestApp.accountingCollectionLedger.help.timestampEntry" />
            </UncontrolledTooltip>
          </dt>
          <dd>{accountingCollectionLedgerEntity.timestampEntry}</dd>
          <dt>
            <Translate contentKey="tinyMedicRestApp.accountingCollectionLedger.expense">Expense</Translate>
          </dt>
          <dd>{accountingCollectionLedgerEntity.expense ? accountingCollectionLedgerEntity.expense.id : ''}</dd>
          <dt>
            <Translate contentKey="tinyMedicRestApp.accountingCollectionLedger.income">Income</Translate>
          </dt>
          <dd>{accountingCollectionLedgerEntity.income ? accountingCollectionLedgerEntity.income.id : ''}</dd>
          <dt>
            <Translate contentKey="tinyMedicRestApp.accountingCollectionLedger.account">Account</Translate>
          </dt>
          <dd>{accountingCollectionLedgerEntity.account ? accountingCollectionLedgerEntity.account.id : ''}</dd>
          <dt>
            <Translate contentKey="tinyMedicRestApp.accountingCollectionLedger.entityType">Entity Type</Translate>
          </dt>
          <dd>{accountingCollectionLedgerEntity.entityType ? accountingCollectionLedgerEntity.entityType.id : ''}</dd>
          <dt>
            <Translate contentKey="tinyMedicRestApp.accountingCollectionLedger.accountingTransaction">Accounting Transaction</Translate>
          </dt>
          <dd>
            {accountingCollectionLedgerEntity.accountingTransactions
              ? accountingCollectionLedgerEntity.accountingTransactions.map((val, i) => (
                  <span key={val.id}>
                    <a>{val.id}</a>
                    {accountingCollectionLedgerEntity.accountingTransactions &&
                    i === accountingCollectionLedgerEntity.accountingTransactions.length - 1
                      ? ''
                      : ', '}
                  </span>
                ))
              : null}
          </dd>
        </dl>
        <Button tag={Link} to="/accounting-collection-ledger" replace color="info" data-cy="entityDetailsBackButton">
          <FontAwesomeIcon icon="arrow-left" />{' '}
          <span className="d-none d-md-inline">
            <Translate contentKey="entity.action.back">Back</Translate>
          </span>
        </Button>
        &nbsp;
        <Button tag={Link} to={`/accounting-collection-ledger/${accountingCollectionLedgerEntity.id}/edit`} replace color="primary">
          <FontAwesomeIcon icon="pencil-alt" />{' '}
          <span className="d-none d-md-inline">
            <Translate contentKey="entity.action.edit">Edit</Translate>
          </span>
        </Button>
      </Col>
    </Row>
  );
};

export default AccountingCollectionLedgerDetail;
